/* Leave without the gift (snippets/cs-gift-leave.liquid), 10 October 2026.

   Catches the first Check out click of a session, in the cart drawer
   (#CartDrawer-Checkout) or on the cart page (#checkout), while the gift
   ladder next to that button says the basket is under the first gift and
   the gift line is not in it. Everything it needs is on the ladder, drawn
   by Liquid: data-spend, data-t1, data-gap1 and the first rung's
   data-cs-gift-in-cart. This file formats no money and does no maths
   beyond one comparison.

   Shown at most once a session (sessionStorage, and a page variable when
   storage is blocked). Escape and the backdrop go on to checkout, like
   "No thanks". Focus stays on the two buttons while it is open; the
   drawer's own focus trap is lifted for that time and put back after. */

(function () {
  'use strict';
  if (window.csGiftLeaveReady) return;
  window.csGiftLeaveReady = true;

  var KEY = 'cs-gift-leave-seen';
  var shownThisPage = false;

  var root = document.querySelector('[data-cs-leave]');
  if (!root) return;
  var card = root.querySelector('.cs-leave__card');
  var gapEl = root.querySelector('[data-cs-leave-gap]');
  var addBtn = root.querySelector('[data-cs-leave-add]');
  var goBtn = root.querySelector('[data-cs-leave-go]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var current = null; /* the Check out button that was pressed */
  var bypass = false;

  function seen() {
    if (shownThisPage) return true;
    try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    shownThisPage = true;
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ }
  }

  function drawerOf(btn) {
    return btn.closest('cart-drawer');
  }

  function ladderFor(btn) {
    return drawerOf(btn)
      ? document.querySelector('#CartDrawer [data-cs-gift]')
      : document.querySelector('#main-cart-footer [data-cs-gift]');
  }

  /* The ladder when the question applies, otherwise null. */
  function shouldAsk(btn) {
    if (seen()) return null;
    var ladder = ladderFor(btn);
    if (!ladder) return null;
    var spend = Number(ladder.getAttribute('data-spend'));
    var t1 = Number(ladder.getAttribute('data-t1'));
    if (!(t1 > 0) || isNaN(spend) || spend >= t1) return null;
    var rung = ladder.querySelector('[data-cs-gift-rung]');
    if (!rung || rung.getAttribute('data-cs-gift-in-cart') === 'true') return null;
    if (!ladder.getAttribute('data-gap1')) return null;
    return ladder;
  }

  function open(btn, ladder) {
    markSeen();
    current = btn;
    gapEl.textContent = ladder.getAttribute('data-gap1');
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    root.hidden = false;
    if (reduced) {
      root.classList.add('is-open');
    } else {
      void root.offsetWidth;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    }
    addBtn.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey, true);
  }

  function close() {
    root.classList.remove('is-open');
    root.hidden = true;
    document.removeEventListener('keydown', onKey, true);
  }

  /* Put the drawer's focus trap back, with focus on the given element. */
  function restoreDrawer(btn, focusEl) {
    var drawer = btn && drawerOf(btn);
    if (drawer && drawer.classList.contains('active') && typeof window.trapFocus === 'function') {
      window.trapFocus(drawer.querySelector('.drawer__inner'), focusEl || btn);
    } else if (focusEl) {
      focusEl.focus({ preventScroll: true });
    }
  }

  function checkout() {
    var btn = current;
    close();
    if (!btn) return;
    bypass = true;
    try {
      if (btn.form && typeof btn.form.requestSubmit === 'function') btn.form.requestSubmit(btn);
      else btn.click();
    } finally {
      bypass = false;
    }
  }

  /* The suggestion that reaches the gift: the drawer's Close the gap row,
     or the product row under the cart page. Scrolled to, and focus put on
     its first button or link. */
  function addLayer() {
    var btn = current;
    close();
    var inDrawer = btn && drawerOf(btn);
    var target = inDrawer ? document.querySelector('#CartDrawer .cs-gap') : document.querySelector('.v2s');
    if (!target) {
      restoreDrawer(btn, btn);
      return;
    }
    target.scrollIntoView({ block: inDrawer ? 'nearest' : 'start', behavior: reduced ? 'auto' : 'smooth' });
    var focusEl = target.querySelector('button:not([disabled]), a[href]');
    if (inDrawer) restoreDrawer(btn, focusEl || btn);
    else if (focusEl) focusEl.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (root.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      checkout();
      return;
    }
    if (e.key === 'Tab') {
      var items = [addBtn, goBtn];
      var i = items.indexOf(document.activeElement);
      e.preventDefault();
      var next = e.shiftKey ? (i <= 0 ? items.length - 1 : i - 1) : (i === items.length - 1 ? 0 : i + 1);
      items[next].focus();
    }
  }

  /* Capture phase, so the click is stopped before the form submits. */
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var btn = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout, #main-cart-footer #checkout') : null;
    if (!btn || btn.disabled) return;
    var ladder = shouldAsk(btn);
    if (!ladder) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(btn, ladder);
  }, true);

  addBtn.addEventListener('click', addLayer);
  goBtn.addEventListener('click', checkout);
  root.querySelector('[data-cs-leave-backdrop]').addEventListener('click', checkout);
  card.addEventListener('click', function (e) { e.stopPropagation(); });
})();
